
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";
  import GET_CONTRACTORS from "@/apollo/autocomplete-queries/GetContractors.gql";
  import DropdownOption from "@/entities/DropdownOption";
  import {Contractor, Query_RootUser_ProfileArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      contractors: {
        query: GET_CONTRACTORS,
        variables() {
          return this.titleAutocompleteFilter;
        },
        update(data) {
          return data.contractor;
        },
        skip() {
          return !this.titleSearchString;
        },
      },
    },
  })

  export default class ContractorsMultiselect extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
  @Prop({ type: String, default: "Select Resource" }) readonly placeholder?: string;

    users: DropdownOption[] = [];
    titleSearchString = "";
    contractors: Contractor[] = []


//     @Watch('titles')
//     changeInTitles(){
// if(this.contractors.length){
//   this.names = this.contractors.map(c => ({id: c.id, name: `${c.user.given_name} ${c.user?.family_name || ''}`}))
// }
// }
get getUsers () {
  const titles = this.contractors.map(c => ({id: c.id, given_name: c.user?.given_name, family_name: c.user?.family_name, name: `${c.user.given_name} ${c.user?.family_name || ''}`}))
this.users = titles
return titles

}
  get placeholderText(): string {
    return this.placeholder;
  }
    get mappedTitleValue(): String[] {
      return this.value.map((item) => item.name);
    }

    get titleAutocompleteFilter(): Query_RootUser_ProfileArgs {
      const conditions: any[] = [
        { 
          user: {

            given_name: { 
              _ilike: `%${this.titleSearchString}%`
            }, 
          }
        },
        { 
          user: {

            given_name: {
              _is_null: false } 
          },
          }
      ]; 

      if (this.mappedTitleValue.length) {
        conditions.push(
          {
            user: {

              given_name: { 
                _nin: this.mappedTitleValue 
              }, 
            }
          },
        );
      }
      return {
        where: { _and: conditions },
        limit: 5,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val)
    }
  }
